import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enCommon from "../locales/en/common.json";
import enPreChat from "../locales/en/pre-chat.json";
import enPostChat from "../locales/en/post-chat.json";

import esCommon from "../locales/es/common.json";
import esPreChat from "../locales/es/pre-chat.json";
import esPostChat from "../locales/es/post-chat.json";

const resources = {
  en: {
    common: enCommon,
    preChat: enPreChat,
    postChat: enPostChat,
  },
  es: {
    common: esCommon,
    preChat: esPreChat,
    postChat: esPostChat,
  },
};
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    ns: ["common", "preChat", "postChat"],
    defaultNS: "common",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["querystring", "navigator", "htmlTag", "localStorage", "cookie"],
      caches: ["localStorage", "cookie"],
      excludeCacheFor: ["cimode"],
      checkWhitelist: true,
      lookupQuerystring: "lang",
    },
    whitelist: ["en", "es"],
  });

export default i18n;
